import { nameByPlatform } from "~/constants/platfroms";
import type { Platform } from "~/types/platform";

export const joinWithAnd = (items: readonly string[]): string =>
  items.length > 1
    ? `${items.slice(0, -1).join(", ")} and ${items.at(-1)}`
    : items.join("");

export const listPlatformNames = (platforms: readonly Platform[]): string =>
  joinWithAnd(platforms.map((platform) => nameByPlatform[platform]));
